module.exports = __webpack_public_path__ + "static/img/hdzs.1465368f.png";